import { render } from "./ImprestPage.vue?vue&type=template&id=4cfc4d53"
import script from "./ImprestPage.vue?vue&type=script&lang=js"
export * from "./ImprestPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__